import { render, staticRenderFns } from "./adddriver.vue?vue&type=template&id=81010f0c&scoped=true"
import script from "./adddriver.js?vue&type=script&lang=js&external"
export * from "./adddriver.js?vue&type=script&lang=js&external"
import style0 from "./adddriver.vue?vue&type=style&index=0&id=81010f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81010f0c",
  null
  
)

export default component.exports